<template>
  <div>
    <div id="circle">
      <canvas :id="this.bindEl"></canvas>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // deg2: sessionStorage.getItem("achVing"),
      deg2: 0,
      Proportion: 0,
    };
  },
  props: {
    Proportion: {
      default: 0,
    },
    timeGone: String,
    textMes: String,
    bindEl: {
      type: String,
      default: "my_html",
    },
  },
  methods: {
    MyProgress(init) {
      this.init(init);
    },
    init(init) {
      this.el = init.el; //元素ID
      let cvsElement = document.getElementById(this.el), //获取元素
        ctx = cvsElement.getContext("2d"), //获取画笔
        width = 110, //元素宽度
        height = 110, //元素高度
        degActive = 0, //动态线条
        degActive1 = 0, //动态线条
        timer = null; //定时器
      //停止时的角度
      init.deg = parseInt(init.deg);
      init.deg > 0 ? (this.deg = init.deg) : (this.deg = 0);
      init.deg2 = parseInt(init.deg2);
      init.deg2 > 0 ? (this.deg2 = init.deg2) : (this.deg2 = 0);

      //线宽
      init.lineWidth !== undefined
        ? (this.lineWidth = init.lineWidth)
        : (this.lineWidth = 20);

      //判断宽高较小者
      this.wh = width > height ? height : width;

      //设置圆的半径，默认为宽高较小者
      init.circleRadius > 0 &&
      init.circleRadius <= this.wh / 2 - this.lineWidth / 2
        ? (this.circleRadius = init.circleRadius)
        : (this.circleRadius = this.wh / 2 - this.lineWidth / 2);

      //绘制线的背景颜色
      init.lineBgColor !== undefined
        ? (this.lineBgColor = init.lineBgColor)
        : (this.lineBgColor = "#ccc");

      //绘制线的颜色
      init.lineColor !== undefined
        ? (this.lineColor = init.lineColor)
        : (this.lineColor = "#009ee5");

      //绘制文字颜色
      init.textColor !== undefined
        ? (this.textColor = init.textColor)
        : (this.textColor = "#009ee5");

      //绘制文字大小
      init.fontSize !== undefined
        ? (this.fontSize = init.fontSize)
        : (this.fontSize = parseInt(this.circleRadius / 2));

      //执行时间
      this.timer = init.timer;

      //清除锯齿
      if (window.devicePixelRatio) {
        cvsElement.style.width = width + "px";
        cvsElement.style.height = height + "px";
        cvsElement.height = height * window.devicePixelRatio;
        cvsElement.width = width * window.devicePixelRatio;
        ctx.scale(window.devicePixelRatio, window.devicePixelRatio);
      }
      //设置线宽
      ctx.lineWidth = this.lineWidth;
      //启动定时器
      timer = setInterval(
        function () {
          ctx.clearRect(0, 0, width, height); //清除画布
          ctx.beginPath(); //开始绘制动态圆
          ctx.arc(
            width / 2,
            height / 2,
            this.circleRadius,
            -Math.PI / 2,
            (degActive * Math.PI) / 180 - Math.PI / 2
          );

          var g = ctx.createLinearGradient(0, 90, 90, 185); //创建渐变对象  渐变开始点和渐变结束点
          g.addColorStop(0, "#0A7263"); //添加颜色点
          g.addColorStop(1, "#E6BA84"); //添加颜色点
          ctx.strokeStyle = g; //使用渐变对象作为圆环的颜色

          // ctx.strokeStyle = "#C04A4A";

          ctx.lineWidth = this.lineWidth;
          ctx.lineCap = "round";
          ctx.stroke();

          ctx.beginPath(); //开始绘制底圆
          ctx.arc(width / 2, height / 2, this.circleRadius, 1, 8);
          ctx.fillStyle = "#F6F6FF";
          ctx.shadowOffsetX = 0;
          ctx.shadowOffsetY = 0;
          ctx.shadowColor = "rgba(0,0,0,0.30)";
          ctx.shadowBlur = 15;
          ctx.fill();

          ctx.beginPath(); //开始绘 time Gone 圆
          ctx.moveTo(55.5, 55.5);
          ctx.arc(
            width / 2,
            height / 2,
            this.circleRadius,
            -Math.PI / 2,
            ((this.deg2 / 100) * 360 * Math.PI) / 180 - Math.PI / 2,
            false
          );
          ctx.lineTo(55.5, 55.5);
          ctx.fillStyle = "#C6E5DF";
          ctx.fill();

          ctx.beginPath();
          ctx.font = 7 + "px SimHei";
          ctx.fillStyle = "#D39D71";
          // ctx.fillText("Time Gone", width / 2, height / 1.4);
          // ctx.fillText(this.textMes, width / 2, height / 1.4);
          ctx.fillText(this.textMes, width / 2.8, height / 1.5);

          ctx.fill();
          let txt = parseInt((degActive * 100) / 360) + "%"; //获取百分比
          ctx.font = this.fontSize + "px SimHei";
          let w = ctx.measureText(txt).width; //获取文本宽度
          let h = this.fontSize / 2;
          ctx.fillStyle = this.textColor;

          ctx.fillText(txt, width / 2 - w / 2, height / 2 + h / 2);

          if (degActive >= (this.deg / 100) * 360) {
            //停止定时器
            clearInterval(timer);
            timer = null;
          }
          degActive++;
        }.bind(this),
        this.timer
      );
    },
  },
  mounted() {
    this.MyProgress({
      el: this.bindEl, //canvas元素id
      deg: Math.round(parseFloat(this.Proportion)), //绘制角度
      deg2: this.deg2,
      timer: 5, //绘制时间
      lineWidth: 25, //线宽
      lineBgColor: "rgba(229,229,229,0.70)", //底圆颜色
      lineColor: "rgba(229,229,229,0.70);", //动态圆颜色
      addColorStop: "rgba(229,229,229,0.70);",
      // strokeStyle: "#84a05f",
      textColor: "#181818", //文本颜色

      fontSize: 20, //字体大小
      circleRadius: 40, //圆半径
      myTxt: parseInt(this.Proportion),
    });
  },
  watch: {
    /* #c7544d 红色 */
    /* #84a05f 绿色 */
    /* #e9c978 黄色 */

    Proportion: function (newData) {
      this.Proportion = newData;

      if (this.Proportion && this.deg2) {
        let precent = parseInt(
          (parseFloat(this.Proportion) / parseFloat(this.deg2)) * 100
        );
        if (precent < 80) {
          this.textColor = "#c7544d"; //红灯
        } else if (precent >= 100) {
          this.textColor = "#84a05f"; //绿灯
        } else {
          this.textColor = "#EEB02B"; //黄灯
        }
      }

      this.MyProgress({
        el: this.bindEl, //canvas元素id
        deg: Math.round(parseFloat(this.Proportion)), //绘制角度
        // deg: "10%", //绘制角度
        deg2: this.deg2, //绘制角度  肤色背景
        timer: 5, //绘制时间
        lineWidth: 25, //线宽
        lineBgColor: "rgba(229,229,229,0.70)", //底圆颜色
        lineColor: "rgba(229,229,229,0.70);", //动态圆颜色
        // textColor: "#181818", //文本颜色
        textColor: this.textColor, //文本颜色
        // strokeStyle: "#84a05f",
        fontSize: 20, //字体大小
        circleRadius: 40, //圆半径
        myTxt: parseInt(this.Proportion),
      });
    },

    timeGone: function (newData) {
      this.deg2 = newData;
      if (this.Proportion && this.deg2) {
        let precent = parseInt(
          (parseFloat(this.Proportion) / parseFloat(this.deg2)) * 100
        );

        if (precent < 80) {
          this.textColor = "#c7544d"; //红灯
        } else if (precent >= 100) {
          this.textColor = "#84a05f"; //绿灯
        } else {
          this.textColor = "#EEB02B"; //黄灯
        }
      }
      this.MyProgress({
        el: this.bindEl, //canvas元素id
        deg: Math.round(parseFloat(this.Proportion)), //绘制角度
        // deg: "0%", //绘制角度 扇形外环的扇形
        // deg: "10%", //绘制角度
        deg2: this.deg2, //绘制角度  肤色背景
        timer: 5, //绘制时间
        lineWidth: 25, //线宽
        lineBgColor: "rgba(229,229,229,0.70)", //底圆颜色
        lineColor: "rgba(229,229,229,0.70);", //动态圆颜色
        // textColor: "#181818", //文本颜色
        textColor: this.textColor,
        // strokeStyle: "#84a05f",
        fontSize: 20, //字体大小
        circleRadius: 40, //圆半径
        myTxt: parseInt(this.Proportion),
      });
    },

    textMes: function (textMes) {
      this.textMes = textMes;
      if (this.Proportion && this.deg2) {
  
        let precent = parseInt(
          (parseFloat(this.Proportion) / parseFloat(this.deg2)) * 100
        );

        if (precent < 80) {
          this.textColor = "#c7544d"; //红灯
        } else if (precent >= 100) {
          this.textColor = "#84a05f"; //绿灯
        } else {
          this.textColor = "#EEB02B"; //黄灯
        }
      }

      this.MyProgress({
        el: this.bindEl, //canvas元素id
        deg: Math.round(parseFloat(this.Proportion)), //绘制角度
        // deg: "10%", //绘制角度
        deg2: this.deg2, //绘制角度  肤色背景
        timer: 5, //绘制时间
        lineWidth: 25, //线宽
        lineBgColor: "rgba(229,229,229,0.70)", //底圆颜色
        lineColor: "rgba(229,229,229,0.70);", //动态圆颜色
        // textColor: "#181818", //文本颜色
        textColor: this.textColor,
        // strokeStyle: "#84a05f",
        fontSize: 20, //字体大小
        circleRadius: 40, //圆半径
        myTxt: parseInt(this.Proportion),
      });
    },
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ButSecoend/public/onlyCir.vue